import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    marginBottom: pxToRem(40),
  },
});
